import React, { PropTypes, Component } from 'react'

function PagerHOC(WrappedComponent){
    return class Pager extends Component {

        constructor(props){
            super(props)
            this.state = { current: 0 }
            this.pager = {}
            this.current = this.current.bind(this)
            this.pager.previous = this.previous.bind(this)
            this.pager.next = this.next.bind(this)
            this.pager.goto = this.goto.bind(this)
            this.pager.setCount = this.setCount.bind(this)
        }

        setCount(count){
            this.count = count
        }
        current(){
            console.log("Pager: Current is fired.")
            return this.state.current ;
        }

        previous() {
            console.log("Pager: Previous is fired.")
            if(this.state.current < 1 ) { return }
            this.goto(this.state.current - 1);
        }

        next() {
            console.log(`Pager: Next is fired. current = ${this.state.current}, count = ${ this.count }`)
            if(this.state.current >= (this.count - 1)) { 
                console.log("Pager: there is not next"); 
                return 
            }else{
                this.goto(this.state.current + 1);
            }
        }
        goto(index) {
            if(index < 0 || index > (this.count - 1 )) { console.log("Pager: Didn't met goto limits " + this.count ); return }
            this.setState({ current: index, });
            console.log("Page: Setting current to " + index)
        }

        render() {
            return (
                <WrappedComponent pager={ this.pager } current={ this.current() } { ...this.props } />
            )
        }
    }
}

export default PagerHOC



// WEBPACK FOOTER //
// ./src/lib/pager.js